<template>
  <v-container fluid style="margin: 0px">
    <v-card
      elevation="0"
      style="
        margin-top: 0px !important;
        margin-bottom: -30px !important;
        overflow: hidden;
        background-color: transparent;
      "
      class="px-5 py-1"
    >
      <v-row
        class="custom-gray-background fill-width d-flex"
        v-if="mostrarFiltro"
      >
        <v-col cols="12" sm="6" md="3">
          <span v-if="modos.length > 0">Filtrar por</span>
          <v-select
            v-model="selectMode"
            :items="modos"
            v-if="modos.length > 0"
            label="Filtrar"
            dense
            solo-inverted
          ></v-select>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <span>Período - Inicial</span>
          <v-menu
            v-model="isStartDatePickerOpen"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template #activator="{ on }">
              <v-text-field
                v-model="selectedStartDate"
                label="Data Inicial"
                dense
                solo-inverted
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              no-title
              v-model="localSelectedStartDateISO"
              @input="handleStartDateSelection"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <span>Período - Final</span>
          <v-menu
            v-model="isEndDatePickerOpen"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template #activator="{ on }">
              <v-text-field
                v-model="selectedEndDate"
                label="Data Final"
                dense
                solo-inverted
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              no-title
              v-model="localSelectedEndDateISO"
              @input="handleEndDateSelection"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <span v-if="opcoes.length > 0">{{ title_opcao }}</span>
          <v-select
            v-model="selectedOpcao"
            v-if="opcoes.length > 0"
            :items="opcoes"
            label="Opção"
            dense
            solo-inverted
          ></v-select>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <span>Empresa</span>
          <v-select
            v-model="selectedCompany"
            @input="handleEmpresaSelection"
            multiple
            :items="filteredEmpresas"
            label="Empresa"
            required
            dense
            solo-inverted
          >
          </v-select>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <span>Tipo</span>
          <v-select
            v-model="selectedType"
            :items="tipos"
            label="Tipo"
            dense
            solo-inverted
          ></v-select>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <span>Produto</span>
          <v-select
            v-model="selectedProduto"
            :items="produtosFiltrados"
            label="Produto"
            dense
            solo-inverted
          ></v-select>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <span>Status</span>
          <v-select
            v-model="selectedStatus"
            :items="status"
            label="Status"
            dense
            solo-inverted
          ></v-select>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-card-actions class="justify-end">
        <v-btn
          @click="alternarVisibilidade"
          color="#4682B4"
          small
          class="mr-2"
          style="font-size: 14px !important; font-weight: bold"
        >
          {{ mostrarFiltro ? "Ocultar Filtro" : "Mostrar Filtro" }}
          <v-icon style="margin-left: 8px" dark>{{
            mostrarFiltro ? "mdi-eye-off" : "mdi-eye"
          }}</v-icon>
        </v-btn>

        <v-btn
          @click="limparFiltro"
          v-if="mostrarFiltro"
          color="#4682B4"
          small
          outlined
          class="mr-2"
          style="font-size: 14px !important; font-weight: bold"
        >
          Limpar
        </v-btn>
        <v-btn
          @click="filtrar"
          v-if="mostrarFiltro"
          color="#4682B4"
          small
          style="font-size: 14px !important; font-weight: bold"
        >
          Filtrar <v-icon style="margin-left: 8px" dark>mdi-filter</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: {
    opcoes: Array,
    modos: Array,
    tipos: Array,
    status: Array,
    produtos: Array,
    campos: String,
    title_opcao: String,
    calendar: String,
  },

  created() {
    if (this.modos.length > 0) {
      this.selectMode = this.modos[0];
    }

    if (this.tipos.length > 0) {
      this.selectedType = this.tipos[0];
    }

    if (this.produtos.length > 0) {
      this.selectedProduto = this.produtos[0];
    }

    if (this.status.length > 0) {
      this.selectedStatus = this.status[0];
    }

    this.selectedEndDate = this.formatDateBR(new Date());

    if (this.calendar === null || this.calendar === "mes") {
      // Se calendar for null ou "mes", obtenha o primeiro dia do mês
      this.selectedStartDate = this.getFirstDayOfMonth();
      //this.selectedStartDate2 = this.getFirstDayOfMonth();
    } else if (this.calendar === "decadas") {
      // Se calendar for "ano", obtenha o primeiro dia do ano
      this.selectedStartDate = this.getFirstDayOf60YearsAgo();
      //this.selectedStartDate2 = this.getFirstDayOf60YearsAgo();
    } else if (this.calendar === "ano") {
      // Se calendar for "ano", obtenha o primeiro dia do ano
      this.selectedStartDate = this.getFirstDayOfYear();
      //this.selectedStartDate2 = this.getFirstDayOfYear();
    } else if (this.calendar === "quinzena") {
      this.selectedStartDate = this.getFirstDayOfMonth();
      this.selectedEndDate = this.getEndDateWithOffset(15);

      //this.selectedStartDate2 = this.getFirstDayOfMonth();
      //this.selectedEndDate2 = this.getEndDateWithOffset(15);
    } else if (this.calendar === "dia") {
      this.selectedStartDate = this.getFirstDayOfMonth();
      this.selectedEndDate = this.getEndDateWithOffset(0);
    } else {
      this.selectedStartDate = this.getFirstDayOfMonth();
    }
  },

  data() {
    return {
      mostrarFiltro: true,
      localSelectedEndDateISO: "",
      localSelectedStartDateISO: "",

      selectedStartDateISO: "",
      selectedEndDateISO: "",

      selectedStartDate: "",
      selectedEndDate: "",

      isStartDatePickerOpen: false,
      isEndDatePickerOpen: false,

      empresa: "Todas",
      selectedProduto: ["Todos"],
      selectedCompany: [""],
      selectedType: "",
      selectedStatus: ["Todos"],
      selectedOpcao: "Todas",
      selectMode: "",
      selectMode2: "",
      user: "",

      empresas: [
        "A FLOR DO CAFÉ",
        "CEMITERIO PREVIDA",
        "CEMITERIO PREVIDA SÃO MIGUEL",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DAS FLORES",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "Todas",
      ],
    };
  },

  computed: {
    filteredEmpresas() {
      // Filtra as empresas com base nos papéis do usuário
      return this.empresas.filter((empresa) => this.hasPermission(empresa));
    },

    produtosFiltrados() {
      // Filtrar os produtos com base nos tipos permitidos
      return this.produtos.filter((produto) =>
        this.tiposPermitidos.includes(produto)
      );
    },
    tiposPermitidos() {
      let tiposPermitidos = ["Todos"];

      if (this.selectedType === "Jazigo") {
        tiposPermitidos = [
          "Todos",
          "CONCESSÃO DE COLUMBÁRIO",
          "CONCESSÃO DE JAZIGOS",
          "CONCESSÃO DE OSSÁRIO",
          "VENDA DE COLUMBÁRIO",
          "VENDA DE JAZIGOS - IMEDIATO",
          "VENDA DE JAZIGOS - PREVENTIVO",
          "VENDA DE JAZIGOS - TRANSITÓRIO",
        ];
      } else if (this.selectedType === "Planos") {
        tiposPermitidos = [
          "Todos",
          "COMPLETO",
          "FAMILIA",
          "INTEGRAL",
          "P23",
          "TOTAL",
          "PF - AMPARO",
          "PROTEÇÃO",
          "PV - AMIGO",
          "PV - BRONZE",
          "PV - CREMAÇÃO COM CERIMÔNIA",
          "PV - DIAMANTE",
          "PV - EMPRESARIAL",
          "PV - EMPRESARIAL - EMPRESA",
          "PV - ESPECIAL",
          "PV - ESMERALDA",
          "PV - ESSENCIAL",
          "PV - IDEAL",
          "PV - MAIOR",
          "PV - MAIS",
          "PV - MASTER GOLD",
          "PV - MELHOR",
          "PV - PLANO PJ",
          "PV - PLUS",
          "PV - POLICIA MILITAR",
          "PV - PRATA",
          "PV - PREVIDA",
          "PV - PREVIPARQ DO AGRESTE",
          "PV - RUBI",
          "PV - SÃO MATHEUS",
        ];
      } else if (this.selectedType === "Cremação") {
        tiposPermitidos = [
          "Todos",
          "CREMAÇÃO",
          "CREMAÇÃO COM CERIMÔNIA",
          "CREMAÇÃO SEM CERIMÔNIA",
          "URNAS CINERARIAS",
        ];
      } else if (
        this.selectedType === "Todos" ||
        this.selectedType === "Funerária" ||
        this.selectedType === "Serviços Administrativos e Cemiteriais" ||
        this.selectedType === "Serviços Cemiteriais"
      ) {
        tiposPermitidos = ["Todos"];
      }

      return tiposPermitidos;
    },
  },

  methods: {
    alternarVisibilidade() {
      this.mostrarFiltro = !this.mostrarFiltro;
    },

    filtrar() {
      // Verificar se pelo menos uma empresa foi selecionada
      if (
        !this.selectedCompany ||
        this.selectedCompany.length === 0 ||
        (this.selectedCompany.length === 1 && this.selectedCompany[0] === "")
      ) {
        // Se não houver empresa selecionada, emitir evento para mostrar o diálogo de erro
        this.$emit("showError");
        return;
      }

      this.$emit("filtrar", {
        selectedOpcao: this.selectedOpcao,
        selectedCompany: this.selectedCompany,
        selectMode: this.selectMode,
        selectedStatus: this.selectedStatus,
        selectedStartDate: this.selectedStartDate,
        selectedEndDate: this.selectedEndDate,
        selectedType: this.selectedType,
        selectedProduto: this.selectedProduto,
        // Adicione outras propriedades conforme necessário
      });
    },

    limparFiltro() {
      (this.empresa = "Todas"),
        (this.selectedCompany = ["Todas"]),
        (this.selectedType = "Todos"),
        (this.selectedOpcao = "Todas"),
        (this.selectedProduto = "Todos");

      if (this.modos.length > 0) {
        this.selectMode = this.modos[0];
      }

      if (this.tipos.length > 0) {
        this.selectedType = this.tipos[0];
      }

      if (this.produtos.length > 0) {
        this.selectedProduto = this.produtos[0];
      }

      if (this.calendar === null || this.calendar === "mes") {
        // Se calendar for null ou "mes", obtenha o primeiro dia do mês
        this.selectedStartDate = this.getFirstDayOfMonth();
      } else if (this.calendar === "decadas") {
        // Se calendar for "ano", obtenha o primeiro dia do ano
        this.selectedStartDate = this.getFirstDayOf60YearsAgo();
      } else if (this.calendar === "ano") {
        // Se calendar for "ano", obtenha o primeiro dia do ano
        this.selectedStartDate = this.getFirstDayOfYear();
      } else if (this.calendar === "quinzena") {
        this.selectedStartDate = this.getFirstDayOfMonth();
        this.selectedEndDate = this.getEndDateWithOffset(15);
      } else if (this.calendar === "dia") {
        this.selectedStartDate = this.getFirstDayOfMonth();
        this.selectedEndDate = this.getEndDateWithOffset(0);
      } else {
        // Se calendar for qualquer outro valor, obtenha o primeiro dia do mês por padrão
        this.selectedStartDate = this.getFirstDayOfMonth();
      }

      this.selectedEndDate = this.formatDateBR(new Date());
    },

    handleStartDateSelection() {
      this.selectedStartDate = this.convertToBR(this.localSelectedStartDateISO);
      this.isStartDatePickerOpen = false;
    },

    handleEndDateSelection() {
      this.selectedEndDate = this.convertToBR(this.localSelectedEndDateISO);
      this.isEndDatePickerOpen = false;
    },

    handleStartDateSelection2() {
      this.selectedStartDate2 = this.convertToBR(
        this.localSelectedStartDateISO2
      );
      this.isStartDatePickerOpen2 = false;
    },

    handleEndDateSelection2() {
      this.selectedEndDate2 = this.convertToBR(this.localSelectedEndDateISO2);
      this.isEndDatePickerOpen2 = false;
    },

    handleStartDateSelection3() {
      this.selectedStartDate3 = this.convertToBR(
        this.localSelectedStartDateISO3
      );
      this.isStartDatePickerOpen3 = false;
    },

    handleEndDateSelection3() {
      this.selectedEndDate3 = this.convertToBR(this.localSelectedEndDateISO3);
      this.isEndDatePickerOpen3 = false;
    },

    convertToISO(dateString) {
      // Converte a data do formato "20/10/2023" para "2023-10-20"
      const [day, month, year] = dateString.split("/");
      return `${year}-${month}-${day}`;
    },

    convertToBR(dateString) {
      // Converte a data do formato ISO "2023-10-20" para "20/10/2023"
      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    },

    getFirstDayOfMonth() {
      const dataAtual = new Date();
      const primeiroDiaDoMes = new Date(
        dataAtual.getFullYear(),
        dataAtual.getMonth(),
        1
      );
      return this.formatDateBR(primeiroDiaDoMes);
    },

    getFirstDayOfYear() {
      const dataAtual = new Date();
      const primeiroDiaDoAno = new Date(dataAtual.getFullYear(), 0, 1); // Janeiro é representado como 0
      return this.formatDateBR(primeiroDiaDoAno);
    },

    handleEmpresaSelection() {
      if (this.selectedCompany.includes("Todas")) {
        // Se "Todas" estiver selecionada, desabilita as outras opções
        this.selectedCompany = ["Todas"];
      }
    },

    hasPermission(empresa) {
      this.user = JSON.parse(sessionStorage.getItem("user"));

      if (this.user.roles.includes("ROLE_ADMIN")) {
        return true;
      } else if (empresa === "Todas") {
        return true;
      } else {
        const requiredRoles = empresa
          .split(",")
          .map(
            (name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_")
          );

        const hasAnyRequiredRole = requiredRoles.some((role) =>
          this.user.roles.includes(role)
        );
        return hasAnyRequiredRole;
      }
    },

    getEndDateWithOffset(offsetDays) {
      const dataAtual = new Date();
      const primeiroDiaDoAno = new Date(
        dataAtual.getFullYear(),
        dataAtual.getMonth(),
        1
      ); // Janeiro é representado como 0

      // Crie a variável endDate aqui
      const endDate = new Date(primeiroDiaDoAno);

      // Adicione o número de dias ao endDate
      endDate.setDate(endDate.getDate() + offsetDays);

      return this.formatDateBR(endDate);
    },

    getFirstDayOf60YearsAgo() {
      const dataAtual = new Date();
      const anoAtual = dataAtual.getFullYear();
      const ano60Atras = anoAtual - 60;
      const primeiroDiaDoAno60Atras = new Date(60, 0, 1); // Janeiro é representado como 0
      return this.formatDateBR(primeiroDiaDoAno60Atras);
    },

    formatDateBR(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const year = parsedDate.getFullYear();
      return `${day}/${month}/${year}`;
    },

    formatDateUS(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const year = parsedDate.getFullYear();
      return `${month}/${day}/${year}`;
    },

    convertToISO(dateString) {
      // Converte a data do formato "20/10/2023" para "2023-10-20"
      const [day, month, year] = dateString.split("/");
      return `${year}-${month}-${day}`;
    },

    convertToBR(dateString) {
      // Converte a data do formato ISO "2023-10-20" para "20/10/2023"
      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
<style>
/* Certifique-se de que o arquivo CSS com a classe .custom-col esteja importado aqui */
.custom-col-13 {
  flex-basis: 13%; /* 15% é equivalente a 1.5 colunas em uma grade de 10 colunas */
  max-width: 13%;
}
.custom-col-15 {
  flex-basis: 15%; /* 15% é equivalente a 1.5 colunas em uma grade de 10 colunas */
  max-width: 15%;
}
</style>
